<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="projectForm">
      <div class="field" [ngClass]="displayFieldCss('organizationShortName')">
        <label class="required">Department Name</label>
        <input
          type="text"
          formControlName="organizationShortName"
          rows="2"
          placeholder="Enter organization name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('organizationShortName')"
          errorMsg="Please enter project name"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('organizationDescription')">
        <label> Description</label>
        <textarea
          formControlName="organizationDescription"
          rows="2"
          placeholder="Enter organization description "
        ></textarea>
        <app-field-error-display
          [displayError]="isFieldValid('organizationDescription')"
          errorMsg="Please enter organizationDescription"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!projectForm.valid || pending"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
